/**
 * Test IDs for QA automation.
 */
export const testIds = {
  receiverForecastDetailsDelete: "receiver-forecast-details-delete",
  receiverForecastDetailsEdit: "receiver-forecast-details-edit",
  receiverForecastDetailsSimulate: "receiver-forecast-details-simulate",
  receiverForecastDetailsUploadCsvReadings: "receiver-forecast-details-upload-csv-readings",
} as const;
